"use strict";

var _classCallCheck = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthorizationInterceptor = void 0;

var add_header_interceptor_1 = require("./add-header.interceptor");

var AuthorizationInterceptor = /*#__PURE__*/function (_add_header_intercept) {
  _inherits(AuthorizationInterceptor, _add_header_intercept);

  var _super = _createSuper(AuthorizationInterceptor);

  function AuthorizationInterceptor(value) {
    var header = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x-auth';

    _classCallCheck(this, AuthorizationInterceptor);

    return _super.call(this, header, value);
  }

  return AuthorizationInterceptor;
}(add_header_interceptor_1.AddHeaderInterceptor);

exports.AuthorizationInterceptor = AuthorizationInterceptor;